export default "__VITE_ASSET__4ce28ec5__"